export type MenuAudience = 'staff' | 'customer';
export interface MenuPage {
  key: string;
  label: string;
  terms: string;
}
export interface MenuGroup {
  key: string;
  label: string;
  terms: string;
  pages: MenuPage[];
}
const page = (key: string, label: string, terms = key): MenuPage => ({ key, label, terms });
const staff: MenuGroup[] = [
  {
    key: 'overview',
    label: 'ภาพรวม',
    terms: 'overview home',
    pages: [page('home', 'หน้าหลัก'), page('work-list', 'รายการงาน', 'work list search ค้นหางาน')],
  },
  {
    key: 'product',
    label: 'ผลิตภัณฑ์',
    terms: 'product',
    pages: [
      page('brief', 'ข้อมูลสินค้า'),
      page('development', 'พัฒนาจากสินค้าอ้างอิง'),
      page('samples', 'ตัวอย่างสินค้า', 'samples sample'),
      page('packaging', 'ผลิตภัณฑ์และบรรจุภัณฑ์'),
      page('artwork', 'แบบฉลากและบรรจุภัณฑ์'),
      page('formulas', 'สูตรและกระบวนการ'),
      page('sample_records', 'ทะเบียนตัวอย่างและการจัดส่ง'),
      page('packaging_records', 'ทะเบียนบรรจุภัณฑ์'),
      page('artwork_records', 'ทะเบียนแบบฉลาก'),
      page('materials', 'วัตถุดิบและเกรด'),
      page('factory-operations', 'ผลิต บรรจุ และปล่อย QA', 'factory batch production packing QA'),
      page('deliveries', 'ติดตามพัสดุที่แชร์', 'delivery parcel tracking'),
      page('stock', 'คลังและร่างจัดซื้อ', 'inventory lot stock warehouse purchasing'),
      page('ingredients', 'ส่วนประกอบ'),
      page('dispatches', 'การจัดส่งตัวอย่าง'),
      page('material_specs', 'สเปกวัตถุดิบผสม'),
      page('processes', 'กระบวนการ'),
      page('densities', 'ผลวัดความหนาแน่น'),
      page('sample_requests', 'คำขอตัวอย่างและค่าใช้จ่าย'),
      page('preparations', 'การเตรียมจริง'),
      page('components', 'ชิ้นส่วน'),
      page('specifications', 'สเปกฉบับที่เลือก'),
    ],
  },
  {
    key: 'review',
    label: 'ทบทวนและหลักฐาน',
    terms: 'review evidence',
    pages: [
      page('reviews', 'ทบทวนและหลักฐาน'),
      page('tests', 'ผลทดสอบ'),
      page('criteria', 'เกณฑ์ที่ตกลง'),
      page('targets', 'รายการที่เลือกและผลกระทบ'),
      page('feasibilities', 'กำลังการผลิต'),
      page('applicabilities', 'เงื่อนไขการทดสอบ'),
      page('test_plans', 'แผนทดสอบ'),
      page('holds', 'เรื่องที่รอแก้ไขและหลักฐาน'),
      page('policies', 'นโยบายที่ทบทวน'),
      page('exceptions', 'ข้อยกเว้นธุรกิจ'),
      page('facts', 'ข้อเท็จจริง'),
    ],
  },
  {
    key: 'commercial',
    label: 'ข้อเสนอและการเงิน',
    terms: 'commercial payment',
    pages: [
      page('quotes', 'ใบเสนอราคาและเงื่อนไข'),
      page('po', 'PO และเงื่อนไขที่เทียบ'),
      page('payments', 'การชำระเงิน'),
      page('handover', 'ยืนยันและส่งต่อ'),
      page('sourcing', 'การจัดหา'),
      page('costs', 'ต้นทุน'),
      page('commitments', 'ข้อผูกพันธุรกิจ'),
      page('proposals', 'เอกสารที่ทบทวน'),
    ],
  },
  {
    key: 'work',
    label: 'จัดการงาน',
    terms: 'work tools',
    pages: [
      page('coordination', 'ค้นหาและการแจ้งเตือน'),
      page('conversations', 'บทสนทนา'),
      page('sync', 'ร่างและผลที่รอตรวจ'),
      page('tasks', 'งานและกำหนดส่ง'),
      page('imports', 'พักข้อมูลนำเข้า'),
      page('activity', 'ประวัติและหลักฐาน'),
      page('documents', 'เอกสาร'),
      page('admin', 'ผู้ใช้งานและสิทธิ์'),
      page('help', 'วิธีใช้และขอบเขต'),
    ],
  },
];
const customerKeys = new Set([
  'home',
  'work-list',
  'brief',
  'development',
  'samples',
  'deliveries',
  'packaging',
  'artwork',
  'quotes',
  'po',
  'payments',
  'handover',
  'coordination',
  'conversations',
  'sync',
  'documents',
  'help',
]);
export function routeGroups(audience: MenuAudience): MenuGroup[] {
  if (audience === 'staff') return staff;
  return ['product', 'commercial', 'work'].map((key) => {
    const group = staff.find((g) => g.key === key);
    if (!group) return { key, label: key, terms: key, pages: [] };
    return {
      ...group,
      pages: [
        ...(key === 'work' ? (staff.find((g) => g.key === 'overview')?.pages ?? []) : []),
        ...group.pages,
      ].filter((p) => customerKeys.has(p.key)),
    };
  });
}

export function permittedPage(audience: MenuAudience, page: string): boolean {
  const canonical = page === 'app' ? 'home' : page === 'confirmation' ? 'handover' : page;
  return routeGroups(audience).some((group) => group.pages.some((item) => item.key === canonical));
}
